import { RootState } from 'types/redux';

export const modalNameSelector = (state: RootState) => state.modal.modalName;

export const modalDataSelector = (state: RootState) => state.modal.data;
